import React, { useState } from 'react'
import { SearchDropdown, HighlightedText } from '@ui'
import fuzzy from 'fuzzaldrin-plus'
import { IIntegration } from '@api/integration/types'
import css from './integrations.module.scss'

interface IIntegrationSearchProps {
  integrations: IIntegration[]
  onSelect: (integraton: IIntegration) => void
}

export default function IntegrationsSearch({ integrations, onSelect }: IIntegrationSearchProps) {
  const [query, setQuery] = useState<string>('')

  const filteredAvailableList = fuzzy.filter(integrations, query, { key: 'name' }).slice(0, 7)

  const search = {
    query,
    items: query ? filteredAvailableList : [],
    run: (s: string) => setQuery(s),
  }

  return (
    <SearchDropdown
      search={search}
      width="400px"
      onSelect={onSelect}
      renderItem={(i: any) => <Integration integration={i} query={query} />}
    />
  )
}

const Integration = ({ integration, query }: { integration: any; query: string }) => (
  <div className={css.container}>
    <img
      height="auto"
      width="40"
      alt="integration"
      src={integration.image}
      style={{ marginRight: 20 }}
    />
    <div>
      <HighlightedText text={integration.name} query={query} />
      <div style={{ color: 'var(--grey1)', fontSize: 12 }}>{integration.category}</div>
    </div>
  </div>
)
